exports.noticiationTypes = {
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
};

exports.notificationStatus = {
  READ: 'READ',
};
